export enum OwnerEntityType {
    All = 0,
    Client = 1,
    Requisition = 2,
    Contact = 3,
    User = 4,
}